import React from "react";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faPhone,
  faEnvelope,
  faLocationDot,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import {
  faFacebookF,
  faTwitter,
  faInstagram,
  faYoutube,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { FaTelegramPlane } from "react-icons/fa";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo, openTelegram } = useLocalContext();

  const brand = webinfo?.name || "Your Brand";
  const logo = webinfo?.logo;
  const phone = webinfo?.phone || "+91 80000 00000";
  const email = webinfo?.email || "hello@example.com";
  const address =
    webinfo?.address || "Remote-first • Supporting businesses worldwide";

  const year = new Date().getFullYear();

  return (
    <footer className="footerx" aria-label={`${brand} website footer`}>
      {/* Top disclaimer strip */}
      {/* <div className="footerx__disclaimer" role="note" aria-live="polite">
        <FontAwesomeIcon icon={faCircleInfo} />
        <p>
          We help small and growing teams keep their IT, tools and websites
          running reliably. This is not an emergency support line.{" "}
          <a href="/disclaimer">View full disclaimer</a>.
        </p>
      </div> */}

      {/* CTA band */}
      <section className="footerx__cta">
        <div className="footerx__cta-inner">
          <div className="footerx__cta-copy">
            <h3>Need a reliable tech & web partner?</h3>
            <p>
              Share where you’re stuck — we’ll send back a simple plan for your
              systems, security, and website.
            </p>
          </div>
          <div className="footerx__cta-actions">
            <button
              type="button"
              className="btn btn--primary"
              onClick={openTelegram}
            >
              <FaTelegramPlane /> Chat on Telegram
            </button>
            <a className="btn btn--ghost" href="/contact">
              Book a quick call →
            </a>
          </div>
        </div>
      </section>

      {/* Main content */}
      <section className="footerx__main">
        {/* Brand / intro / newsletter */}
        <div className="fcard fcard--brand">
          <div className="brand">
            {/* {logo && (
              <img src={logo} alt={`${brand} logo`} className="brand__logo" />
            )} */}
            <div className="brand__text">
              <h4>{brand}</h4>
              <p>
                Practical support for printers, security, Microsoft 365, web and
                CRM — so your team can focus on actual work.
              </p>
            </div>
          </div>

          <form
            className="newsletter"
            onSubmit={(e) => e.preventDefault()}
            aria-label="Subscribe for updates"
          >
            <input
              type="email"
              placeholder="Work email address"
              aria-label="Email address"
              required
            />
            <button type="submit" aria-label="Subscribe">
              <span>Join list</span>
            </button>
          </form>

          <div className="socials" aria-label="Social links">
            <a href="#" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
            <a href="#" aria-label="Twitter / X">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="#" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="#" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>
            <a href="#" aria-label="YouTube">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
          </div>
        </div>

        {/* Link columns */}
        <nav className="fcard fcard--links" aria-label="Footer navigation">
          <div>
            <h5>Services</h5>
            <ul>
              <li>
                <a href="/services/printer-support">Printer Support</a>
              </li>
              <li>
                <a href="/services/antivirus-security">Antivirus & Security</a>
              </li>
              <li>
                <a href="/services/microsoft-365">Microsoft 365</a>
              </li>
              <li>
                <a href="/services/web-development">Web Development</a>
              </li>
              <li>
                <a href="/services/crm-development">CRM & Automation</a>
              </li>
              <li>
                <a href="/services/accounting-bookkeeping">
                  Accounting & Bookkeeping
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h5>Company</h5>
            <ul>
              <li>
                <a href="/about">About {brand}</a>
              </li>
              <li>
                <a href="/blogs">Blog & Updates</a>
              </li>
              <li>
                <a href="/case-studies">Case Studies</a>
              </li>
              <li>
                <a href="/contact">Contact & Support</a>
              </li>
            </ul>
          </div>

          <div>
            <h5>Resources</h5>
            <ul>
              <li>
                <a href="/guides/getting-started">Getting started guide</a>
              </li>
              <li>
                <a href="/guides/security-checklist">
                  Small business security checklist
                </a>
              </li>
              <li>
                <a href="/guides/it-handbook">Simple IT handbook</a>
              </li>
            </ul>
          </div>
        </nav>

        {/* Contact column */}
        <aside className="fcard fcard--contact" aria-label="Contact details">
          <h5>Contact</h5>
          <ul className="contact-list">
            <li>
              <FontAwesomeIcon icon={faPhone} />
              <a href={`tel:${phone}`}>{phone}</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faEnvelope} />
              <a href={`mailto:${email}`}>{email}</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faLocationDot} />
              <span>{address}</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faClock} />
              <span>Mon–Fri • 9:00 AM – 6:00 PM (IST)</span>
            </li>
          </ul>

          <div className="badges">
            <span>Ticket-based support</span>
            <span>Remote-first team</span>
            <span>Clear, simple billing</span>
          </div>
        </aside>
      </section>

      {/* Trust stats row */}
      <section className="footerx__trust">
        <div className="trust-item">
          <strong>3000+</strong>
          <span>Support tickets resolved</span>
        </div>
        <div className="trust-item">
          <strong>120+</strong>
          <span>Businesses supported</span>
        </div>
        <div className="trust-item">
          <strong>98%</strong>
          <span>Customer satisfaction</span>
        </div>
        <div className="trust-item">
          <strong>24–48h</strong>
          <span>Usual resolution window</span>
        </div>
      </section>

      {/* Bottom row */}
      <div className="footerx__bottom">
        <p>
          © {year} {brand}. All rights reserved.
        </p>
        <ul className="legal-mini">
          <li>
            <a href="/privacy-policy">Privacy</a>
          </li>
          <li>
            <a href="/terms-and-condition">Terms</a>
          </li>
          <li>
            <a href="/disclaimer">Disclaimer</a>
          </li>
          <li>
            <a href="/contact">Support</a>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
